export default __webpack_public_path__ + "static/media/avatar-neutral.47b765fd.svg";